import clsx from 'clsx';
import _ from 'lodash';
import Moment from 'moment';
import React, { lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';

import { axios } from '@/src/lib/axios/axios';
import { generateRoutePath, INBOX_PATH } from '@/src/routes';
import { Library } from './Library/Library';

import SectionLoader, {
  LOADER_POSITION,
  LOADER_TYPE,
} from '../common/Elements/Spinner/SectionLoader/SectionLoader';
import ProjectMenu from '../main/Header/ProjectMenu/ProjectMenu';

const ProjectDashboard = lazy(() => import('./Dashboard/Dashboard'));
const ProjectProcesses = lazy(() => import('./Processes2/Processes'));
const Settings = lazy(() => import('./Settings/Settings'));
const Inbox2 = lazy(() => import('./Inbox2/Inbox'));
const ProjectConversations = lazy(() => import('./Conversations/Conversations'));
const ProjectReports = lazy(() => import('./ProjectReports'));
const NotAvailable = lazy(() => import('../notAvailable'));
const defaults = {
  holidays: [
    { date: null, name: null },
    { date: null, name: null },
    { date: null, name: null },
  ],
};

export const getProjectPageUrl = (projectId) => generateRoutePath(INBOX_PATH, { projectId });

@connect((store) => {
  return {
    project: store.project,
    task: store.task,
    loggedUser: store.loggedUser,
  };
})
export default class ProjectDetails extends React.Component {
  constructor(props) {
    super(props);
    _.map(['fetchProjectDetails'], (fn) => {
      this[fn] = this[fn].bind(this);
    });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.match.params.projectId !== this.props.match.params.projectId) {
      this.fetchProjectDetails();
      this.fetchConversationCount();
    }
    // Refetch project details if lookerReportUrl changes
    const prevShow = prevProps.project.Selected?.lookerReportUrl;
    const currShow = this.props.project.Selected?.lookerReportUrl;

    const prevShowLooker = prevProps.project.Selected?.showLookerReport;
    const currShowLooker = this.props.project.Selected?.showLookerReport;
    
    if (prevShow !== currShow || prevShowLooker !== currShowLooker) {
      this.fetchProjectDetails();
    }
  }
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({ type: 'SET_PROJECT_FILTER', filter: { ['typeId']: 1 } });

    this.fetchProjectDetails();
    this.fetchConversationCount();
  }

  fetchConversationCount = () => {
    const { dispatch, match } = this.props;
    const { projectId } = match.params;

    if (projectId) {
      axios.get(`/api/conversation/getUnreadCount`, { params: { projectId } }).then((data) => {
        dispatch({ type: 'SET_CONVERSATION_COUNT', count: data.count });
      });
    }
  };

  componentWillUnmount() {
    const { dispatch } = this.props;

    dispatch({ type: 'SET_PROJECT_SELECTED', Selected: {} });
  }

  fetchProjectDetails() {
    const { match, dispatch } = this.props;
    const projectId = match.params.projectId;
    let url = `/api/project/detail/${projectId}?info=${1}`;
    if (localStorage.getItem('onEdit') && Boolean(localStorage.getItem('onEdit'))) {
      url += '&action=edit';
    }
    axios(url).then((responseProject) => {
      setTimeout(() => {
        if (responseProject) {
          dispatch({ type: 'SET_PROJECT_SELECTED', Selected: responseProject });

          // Fetch members from actual endpoint
          if (this.props.loggedUser.data.userRole <= 4) {
            axios(`/api/projects/${projectId}/members`).then((membersResponse) => {
              const selectedWithMembers = {
                ...responseProject,
                members: membersResponse, // Use actual members data
              };
              dispatch({ type: 'SET_PROJECT_SELECTED', Selected: selectedWithMembers });
              dispatch({ type: 'SET_PROJECT_LOADING', Loading: '' });
              dispatch({
                type: 'SET_PROJECT_TYPE',
                projectType: responseProject.typeId === 1 ? 'company' : 'project',
              });
              dispatch({
                type: 'UPDATE_SETTINGS_INIT',
                data: {
                  list: responseProject.calendars_list,
                  calendars: {
                    default: responseProject.project_calendar.default,
                    others: responseProject.project_calendar.others.map((c) => c.calendars),
                  },
                  workingDays: responseProject.project_workdays,
                  holidays: [
                    ...responseProject.project_holiday
                      .filter((h) => h.date)
                      .map((h) => ({ date: Moment(h.date).format('DD-MMM YYYY'), holiday: h.holiday })),
                    ...(responseProject.project_holiday.filter((h) => h.date).length < 3
                      ? defaults.holidays.filter(
                          (h, i) =>
                            i >= responseProject.project_holiday.filter((h) => h.date).length && i < 3
                        )
                      : []),
                  ],
                },
              });
              localStorage.removeItem('onEdit');
            });
          } else {
            dispatch({ type: 'SET_PROJECT_LOADING', Loading: '' });
            dispatch({
              type: 'SET_PROJECT_TYPE',
              projectType: responseProject.typeId === 1 ? 'company' : 'project',
            });
            dispatch({
              type: 'UPDATE_SETTINGS_INIT',
              data: {
                list: responseProject.calendars_list,
                calendars: {
                  default: responseProject.project_calendar.default,
                  others: responseProject.project_calendar.others.map((c) => c.calendars),
                },
                workingDays: responseProject.project_workdays,
                holidays: [
                  ...responseProject.project_holiday
                    .filter((h) => h.date)
                    .map((h) => ({ date: Moment(h.date).format('DD-MMM YYYY'), holiday: h.holiday })),
                  ...(responseProject.project_holiday.filter((h) => h.date).length < 3
                    ? defaults.holidays.filter(
                        (h, i) =>
                          i >= responseProject.project_holiday.filter((h) => h.date).length && i < 3
                      )
                    : []),
                ],
              },
            });
            localStorage.removeItem('onEdit');
          }
        } else {
          if (responseProject && responseProject.message && responseProject.message.error) {
            if (responseProject.message.error === 'Page Not found') {
              window.location.href = '/account#/not-found';
            } else if (responseProject.message.error === 'Inactive Project') {
              localStorage.setItem(
                'inactive_project',
                JSON.stringify(responseProject.message.details)
              );
              window.location.href = '/account#/inactive-project';
            } else {
              window.location.href = '/account#/not-found';
            }
          } else {
            window.location.href = '/account#/inactive-project';
          }
          localStorage.removeItem('onEdit');
        }
      }, 100);
    });
  }

  render() {
    if (!this.props.project.Selected) {
      return (
        <SectionLoader loaderType={LOADER_TYPE.screen} loaderPosition={LOADER_POSITION.absolute} />
      );
    }

    return (
      <React.Fragment>
        <div
          id="project-nav-bar"
          className={clsx('main-bar', 'tw-sticky  tw-top-0 tw-z-[3]', 'tw-bg-white')}
        >
          <ProjectMenu />
        </div>
        <Suspense
          fallback={
            <div className={clsx('tw-relative', 'tw-h-[calc(100vh-110px)]')}>
              <SectionLoader
                loaderType={LOADER_TYPE.screen}
                loaderPosition={LOADER_POSITION.absolute}
              />
            </div>
          }
        >
          <Switch>
            <Route
              exact={true}
              path={`${this.props.match.path}`}
              render={props => (
                <ProjectDashboard {...props} fetchProjectDetails={this.fetchProjectDetails} />
              )}
            />
            <Route path={`${this.props.match.path}/processes`} component={ProjectProcesses} />
            {/* <Route
              exact={true}
              path={`${this.props.match.path}/calendar`}
              component={ProjectTaskCalendar}
            /> */}
            <Route exact={true} path={`${this.props.match.path}/files`} component={Library} />
            <Route exact={true} path={`${this.props.match.path}/inbox`} component={Inbox2} />
            <Route
              exact={true}
              path={`${this.props.match.path}/conversations`}
              component={ProjectConversations}
            />
            <Route exact={false} path={`${this.props.match.path}/reports`} component={ProjectReports} />
            <Route path={`${this.props.match.path}/settings`} component={Settings} />
            <Route path={`*`} component={NotAvailable} />
          </Switch>
        </Suspense>
      </React.Fragment>
    );
  }
}
